<template>
<div class="mt_140">

      <ccMenu ref="cc_menu"></ccMenu>
      <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

      <div class="container">
      <div class="row">
      <div class="col-md-12">

        <!-- row -->
        <div class="row">

            <!-- coluna 2 -->
            <div class="col-md-2">
              <ccMenuConta :num=2></ccMenuConta>
            </div">
            <!-- fim coluna 2 -->

            <!-- coluna 10 -->
            <div class="col-md-10 p-4" style="background: transparent linear-gradient(152deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box; box-shadow: 0px 3px 6px #00000029;">

                <!-- DADOS PESSOAIS -->
                <section class="mb-3 travado" v-bind:class="[{travado_div:travado==true}]">

                  <div class="text_laranja text-center mb-3" v-show="loading">
                    <div class="spinner-grow spinner-grow-sm" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    Carregando
                  </div>

                  <div class="row mb-3">
                    <div class="col-6 text_12 text_bold text_cinza">DADOS PESSOAIS* &nbsp; ID da conta: {{user.id}}</div>
                    <div v-if="travado==false" class="col-6 text_12  text-end text_verde"> Editar </div>
                  </div>

                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-6">
                          <input type="text" v-model="nome_completo" class="form-control disabled" placeholder="Nome Completo" disabled>
                        </div>
                        <div class="col-6">
                          <the-mask :mask="['###.###.###-##']" masked type="text" v-model="cpf" class="form-control text_bold disabled" placeholder="CPF" disabled />
                        </div>
                        <div class="col-6">
                          <the-mask :mask="['##/##/####']" masked type="text" v-model="nascimento" class="form-control disabled" placeholder="Nascimento" disabled/>
                        </div>
                        <div class="col-6">
                          <input type="text" v-model="username" class="form-control disabled text_bold text_12" placeholder="User Name" disabled>
                        </div>
                        <div class="col-6">
                          <input type="text" v-model="rg" class="form-control" placeholder="RG">
                        </div>
                        <div class="col-md-6">
                          <the-mask :mask="['(##)#####-####']" masked type="text" v-model="telefone" class="form-control" placeholder="Telefone" />
                        </div>
                      </div>
                    </div>
                  </div>

                </section>

                <!-- ENDEREÇO -->
                <section class="mb-3 travado" v-bind:class="[{travado_div:travado==true}]">
                  <div class="row mb-3">
                    <div class="col-6 text_12 text_bold text_cinza"> ENDEREÇO </div>
                    <div v-if="travado==false" class="col-6 text_12  text-end text_verde"> Editar </div>
                  </div>

                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6">
                          <input type="text" v-model="rua" class="form-control" placeholder="Rua, Número">
                        </div>
                        <div class="col-md-6">
                          <input type="text" v-model="bairro" class="form-control" placeholder="Bairro">
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <select class="form-control text_13" v-model="estado_id" placeholder="Selecione um Estado" style="padding: 10px;">
                              <option value=0 hidden disabled selected>Selecione um Estado</option>
                              <option v-for="estado in estados" v-bind:value="estado.id"> {{ estado.nome }} </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <the-mask :mask="['#####-###']" masked type="text" v-model="cep" class="form-control" placeholder="CEP" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <!-- INFORMAÇÕES DE CONTATO -->
                <section class="mb-3 travado" v-bind:class="[{travado_div:travado==true}]">
                  <div class="row mb-3">
                    <div class="col-6 text_12 text_bold text_cinza"> INFORMAÇÕES DE CONTATO </div>
                    <div v-if="travado==false" class="col-6 text_12  text-end text_verde"> Editar </div>
                  </div>

                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6">
                          <input type="text" v-model="email" class="form-control disabled" placeholder="Email" disabled>
                        </div>
                        <div class="col-md-6">
                          <input type="text" v-model="telefone" class="form-control" placeholder="Número de Telefone (DDD + Número)">
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <!-- BOTAO SALVAR DADOS -->
                <section>
                  <div class="row mb-3">
                    <div class="col-md-4 text_12 text_bold text_cinza text-end">
                      <button v-if="travado==false" class="btn btn-outline-danger w-100 btn-sm mt-3" @click="travar_funcao_editar()">CANCELAR</button>
                    </div>
                    <div class="col-md-4 offset-4 text_12 text_bold text_cinza text-end">
                      <button v-if="travado==true" class="btn btn-outline-info w-100 btn-sm mt-3" @click="habilitar_funcao_editar()">EDITAR DADOS DA CONTA</button>
                      <button v-if="travado==false" class="btn btn-outline-success w-100 btn-sm mt-3" @click="save()">SALVAR DADOS DA CONTA</button>
                    </div>
                  </div>
                </section>

            </div>
          <!-- fim coluna 10 -->

        </div>
        <!-- fim row -->

    </div>
    </div>
    </div>

    <ccFooter></ccFooter>

</div>
</template>

<script>

import axios from 'axios';
import { TheMask } from 'vue-the-mask';
import ccMenu from '../layout/menu.vue'
import ccMenuConta from '../conta/menu_conta.vue'
import ccLoading from '../cc_geral/cc_loading.vue'
import ccFooter from '../layout/footer.vue'

export default {

  data() {
    return {
      titulo: 'MEUS DADOS',

      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: true,
      errors: [],

      //funcao editar
      travado: true,

      //variaveis
      nome_completo: null,
      cpf: null,
      email: null,
      rg: null,
      nascimento: null,
      username: null,
      rua: null,
      bairro: null,
      cep: null,
      telefone: null,
      estados: [],
      estado_id: null,
    }
  },

  components: { ccMenu, TheMask, ccMenuConta, ccLoading, ccFooter },

  created() {

    document.title = 'Minha Conta: Dados - SokkerDuel';

    localStorage.setItem("base_url_api_mobile", this.base_url_api)

    let a = JSON.parse(localStorage.getItem("user"));
    if (a == null) { this.user = {} } else { this.user = a }

    this.get_estados()
    this.get_user_completo()
  },

  methods: {

    get_estados() {
      this.loading = true;

      //get todos os estados do brasil
      var header = { 'headers': { 'x-access-token': this.user.access_token, } };
      axios.get(this.base_url_api + 'estados/brasil', header)
        .then(response => {
          this.estados = response.data.resp
          this.loading = false
        })
        .catch(e => {
          this.errors.push(e);
          this.loading = false;
        });
    },

    get_user_completo() {
      this.loading = true;
      var header = { 'headers': { 'x-access-token': this.user.access_token, } };
      axios.get(this.base_url_api + 'user/completo', header)
        .then(response => {

          var aux_data = null
          if (response.data.resp.nascimento != null) {
            var ano = response.data.resp.nascimento.substring(0, 4);
            var mes = response.data.resp.nascimento.substring(5, 7);
            var dia = response.data.resp.nascimento.substring(8, 10);
            aux_data = dia + '/' + mes + '/' + ano
          }

          this.id = response.data.resp.id
          this.username = response.data.resp.username;
          this.nome_completo = response.data.resp.nome_completo
          this.cpf = response.data.resp.cpf
          this.email = response.data.resp.email
          this.rg = response.data.resp.rg
          this.nascimento = aux_data
          this.rua = response.data.resp.rua
          this.bairro = response.data.resp.bairro
          this.estado_id = response.data.resp.estado_id
          this.estado = response.data.resp.estado
          this.cep = response.data.resp.cep
          this.telefone = response.data.resp.telefone

          this.loading = false;
        })
        .catch(e => {
          this.errors.push(e);
          alert(e)
          this.expluse_para_login()
        });
    },

    sair() {
      this.user = {}
      localStorage.setItem("user", null);
      this.user_logado = false
    },


    save() {
      this.loading = true;

      var body = {
        email: this.email,
        rg: this.rg,
        rua: this.rua,
        bairro: this.bairro,
        estado_id: this.estado_id,
        // estado: this.estado,
        cep: this.cep,
        telefone: this.telefone,
      };

      var header = { 'headers': { 'x-access-token': this.user.access_token, } };
      axios.post(this.base_url_api + 'user/update', body, header)
        .then(response => {
          alert("Registro salvo com sucesso!")
          this.loading = false
          this.travado = true
        })
        .catch(e => {
          this.errors.push(e);
          this.expluse_para_login()
        });
    },

    habilitar_funcao_editar(){
      this.travado = false
    },

    travar_funcao_editar(){
      this.travado = true
    },

  }

}
</script>

<style scoped>
  .card{
    background: #FFFFFF08 0% 0% no-repeat padding-box;
    color:#fff;
  }

  input.form-control {
    background: transparent linear-gradient(180deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box;
    color: #909196;
    margin-bottom: 10px;
    border: none;
    padding: 10px;
    font-size: 13px;
  }

  input.form-control.disabled {
    background-color: #21232d;
    background-image: url("../../assets/image/cadeado.svg");
    background-size: 20px;
    background-position: right;
    background-repeat: no-repeat;
  }

  select.form-control {
    background: transparent linear-gradient(180deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box;
    color: #909196;
    margin-bottom: 10px;
    border: none;
    padding: 10px;
    font-size: 13px;
  }

  input.form-control::placeholder {
    color: #B7B7B780;
    font-size: 13px;
  }

  option[value=0] {
    color: red;
  }

  .travado_div{
    pointer-events: none;
    opacity: 0.8;
  }

</style>



// WEBPACK FOOTER //
// src/components/conta/dados.vue